/* src/app/components/shop-card/shop-card.component.scss */
:host {
  --page-margin: var(--app-fair-margin);
  --page-background: var(--app-background);
  --page-items-gutter: calc(var(--page-margin) / 2);
  --page-color: #cb328f;
}
.fashion-listing-content {
  --background: var(--page-background);
  --padding-start: var(--page-margin);
  --padding-end: var(--page-margin);
  --padding-top: var(--page-margin);
  --padding-bottom: var(--page-margin);
}
ion-row {
  padding: 0;
}
.listing-item {
  padding: 0;
}
.listing-item .item-image-wrapper {
  border: 1px solid var(--ion-color-light-shade);
  border-radius: 10px;
}
.listing-item .item-image-wrapper .image-anchor {
  display: block;
}
.listing-item .item-image-wrapper .image-anchor img {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.listing-item .item-body {
  --ion-grid-column-padding: 0px;
  padding: 5px 5px 0px;
  text-align: center;
}
.listing-item .item-body .main-info {
  margin-bottom: calc(var(--page-margin) / 2);
}
.listing-item .item-body .main-info .item-name {
  margin: 0px;
  font-size: 14px;
  font-weight: 400;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.listing-item .item-body .main-info .item-name .name-anchor {
  color: var(--ion-color-primary);
  display: block;
  text-decoration: none;
}
.listing-item .item-body .secondary-info {
  align-items: center;
}
.listing-item .item-body .secondary-info .price-col:first-child {
  padding-right: calc(var(--page-margin) / 2);
  text-align: right;
}
.listing-item .item-body .secondary-info .price-col:first-child:last-child {
  text-align: center;
}
.listing-item .item-body .secondary-info .price-col:last-child {
  padding-left: calc(var(--page-margin) / 2);
  text-align: left;
}
.listing-item .item-body .secondary-info .separator {
  max-width: 0px;
  border-right: solid 2px var(--ion-color-light-shade);
  align-self: stretch;
}
.listing-item .item-body .secondary-info .item-sale-price {
  display: block;
  font-weight: 400;
  color: var(--page-color);
  font-size: 16px;
}
.listing-item .item-body .secondary-info .item-original-price {
  display: block;
  text-decoration: line-through;
  color: var(--ion-color-medium-shade);
  font-size: 14px;
}
/*# sourceMappingURL=shop-card.component-5M2TAUE2.css.map */
